<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="16.787624"
    height="7.685658"
    viewBox="0 0 16.787624 7.685658"
    version="1.1"
    id="probability-logo"
  >
    <defs id="defs821">
      <inkscape:perspective
        sodipodi:type="inkscape:persp3d"
        inkscape:vp_x="0 : 12 : 1"
        inkscape:vp_y="0 : 1000 : 0"
        inkscape:vp_z="23.999999 : 12 : 1"
        inkscape:persp3d-origin="12 : 8 : 1"
        id="perspective1253"
      />
    </defs>
    <rect
      style="fill:#eeeeeeff;stroke:none;stroke-width:0.56858873;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.63500001"
      id="rect847-6-7"
      class="bar animate5"
      width="1.7917485"
      height="7.685658"
      x="8.1117916"
      y="0"
    />
    <rect
      style="fill:#eeeeeeff;stroke:none;stroke-width:0.44087705;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.63500001"
      id="rect847-6-7-8"
      class="bar animate"
      width="1.7917485"
      height="4.6208253"
      x="10.822989"
      y="3.0648327"
    />
    <rect
      style="fill:#eeeeeeff;stroke:none;stroke-width:0.33623421;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.63500001"
      id="rect847-6-7-8-3"
      class="bar animate4"
      width="1.7917485"
      height="2.687623"
      x="13.534188"
      y="4.9980345"
    />
    <rect
      style="fill:#eeeeeeff;stroke:none;stroke-width:0.41777819;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.63500001"
      id="rect847-6-7-89"
      class="bar animate3"
      width="1.7917485"
      height="4.149312"
      x="5.4005923"
      y="3.5363455"
    />
    <rect
      style="fill:#eeeeeeff;stroke:none;stroke-width:0.32114863;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.63500001"
      id="rect847-6-7-89-1"
      class="bar animate2"
      width="1.7917485"
      height="2.4518661"
      x="2.6893947"
      y="5.2337914"
    />
    <path
      style="fill:none;stroke:#fa6940;stroke-width:0.34015748;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      d="M 0.00177168,7.5155884 C 5.5664921,7.4576184 5.9428325,0.27787136 9.0076653,0.27787136 c 2.8290767,0 3.3005877,7.19056904 7.7799597,7.19056904"
      id="path933"
      inkscape:connector-curvature="0"
      sodipodi:nodetypes="csc"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss">
#probability-logo {
  height: 30em;
  width: 100%;
  max-width: 30em;
}

.bar {
  transform-origin: 0% 100%;
}
.animate {
  animation: move 6s infinite !important;
}

.animate2 {
  animation: move2 2s infinite !important;
}

.animate3 {
  animation: move 4.5s infinite !important;
}

.animate4 {
  animation: move2 4s infinite !important;
}

.animate5 {
  animation: move3 6s infinite !important;
}
@keyframes move {
  0% {
    transform: scaleY(1);
  }
  25% {
    transform: scaleY(1.2);
  }
  50% {
    transform: scaleY(1);
  }
  75% {
    transform: scaleY(1.2);
  }
  100% {
    transform: scaleY(1);
  }
}

@keyframes move2 {
  5% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.2);
  }
  95% {
    transform: scaleY(1);
  }
}
@keyframes move3 {
  5% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.1);
  }
  95% {
    transform: scaleY(1);
  }
}

@media only screen and (max-width: 500px) {
  #probability-logo {
    width: 80%;
  }
}
</style>
